import { BOTH_DEFAULT_AND_LEGACY_DATA, DEFAULT_ONLY_DATA, LEGACY_ONLY_DATA, } from 'AccountsApp/ts/constants/user-preferences.constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
export class DataMenuSettingPreferenceComponent {
    constructor(accountsService) {
        this.accountsService = accountsService;
        this.selectedDataMenuOption = LEGACY_ONLY_DATA;
        this.dataMenuOptionConfig = {
            list: [
                { type: 'option', label: 'Legacy Only', value: LEGACY_ONLY_DATA },
                { type: 'option', label: 'Default Only', value: DEFAULT_ONLY_DATA },
                { type: 'option', label: 'Both Default and Legacy', value: BOTH_DEFAULT_AND_LEGACY_DATA },
            ],
        };
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.selectedDataMenuOption = preference.data_menu_setting;
        });
    }
    setDataMenuOption(dataMenuOption) {
        this.accountsService.putUserPreferences({ data_menu_setting: dataMenuOption }).subscribe();
    }
}
DataMenuSettingPreferenceComponent.ɵfac = function DataMenuSettingPreferenceComponent_Factory(t) { return new (t || DataMenuSettingPreferenceComponent)(i0.ɵɵdirectiveInject(i1.AccountsService)); };
DataMenuSettingPreferenceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataMenuSettingPreferenceComponent, selectors: [["ycn-data-menu-setting-preference"]], decls: 7, vars: 2, consts: [["help", ""], [1, "topics-section-header"], [1, "help-toggler", 3, "click"], [3, "changeHandler", "selectedValue", "config"]], template: function DataMenuSettingPreferenceComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵtext(1, "Data Menu Settings ");
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵlistener("click", function DataMenuSettingPreferenceComponent_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r1); const help_r2 = i0.ɵɵreference(6); return i0.ɵɵresetView(help_r2.openModal("data_menu_settings")); });
        i0.ɵɵtext(3, "(?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "ycn-single-select-dropdown", 3);
        i0.ɵɵlistener("changeHandler", function DataMenuSettingPreferenceComponent_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setDataMenuOption($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("selectedValue", ctx.selectedDataMenuOption)("config", ctx.dataMenuOptionConfig);
    } }, dependencies: [i2.HelpModalComponent, i3.SingleSelectDropdownComponent], encapsulation: 2 });
